import { HelpersService } from './../../services/tools/helpers.service';
import { ConceptosService } from '../../services/conceptos.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import {ValidatorService} from "../../services/tools/validator.service";
import {Globals} from './../../services/tools/Globals.service';
declare var jquery;
declare var $;

@Component({
  selector: 'app-catalogo-conceptos',
  templateUrl: './catalogo-conceptos.component.html',
  styleUrls: ['./catalogo-conceptos.component.scss']
})
export class CatalogoConceptosComponent implements OnInit {

  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;

  conceptos:any[];
  searchText:string = "";
  conceptoSelected:any;
  mostrarListado:boolean = true;
  errors:any = {};
  searchProcess:any;
  statuses:any = {};
  paginate:any = {};
  tiposMovimiento:any[];
  tiposIngreso:any[];
  tiposEgreso:any[];
  tiposClasificacion:any[];
  currentPage: any = 1;
  lastPage: any = 1;
  processing: any = false;
  alterTable: any = 'starting';
  exporting: any = false;
  isValid: any='starting';

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  constructor(  private conceptosService: ConceptosService,
                private validatorService: ValidatorService,
                private helperService: HelpersService,
                private globals: Globals) { }

  ngOnInit() {
    this.getConceptos();
    this.deleteConcepto = this.deleteConcepto.bind(this);
    this.resetConceptoSelected = this.resetConceptoSelected.bind(this);
    this.tiposClasificacion = this.conceptosService.getTiposClasificacion();
    this.tiposIngreso = this.conceptosService.getTiposIngreso();
    this.tiposEgreso = this.conceptosService.getTiposEgreso();
    this.tiposMovimiento = this.conceptosService.getTiposMovimiento();
    this.globals.passwordActivate = false;
  }

  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }

  resetConceptoSelected(){
    this.conceptoSelected = undefined;
    this.errors = {};
  }

  startConceptoSelected(){
    this.resetConceptoSelected();
    this.conceptoSelected = this.conceptosService.getDefaultSchedule();
  }

  selectConcepto(concepto){
    this.resetConceptoSelected();
    const conceptoCloned = JSON.parse(JSON.stringify( concepto ));
    this.conceptoSelected = conceptoCloned;
  }

  SelectedConceptoClass(concepto) {

    return (this.validatorService.required(this.conceptoSelected) && this.conceptoSelected.idConceptos == concepto.idConceptos)?"active":"";
  }

  confirmDeleteConcepto(){
    this.confirmModal.open({
      'title': 'Eliminar Concepto',
      'description': '¿Está seguro que desea eliminar este Concepto?',
      'callback': this.deleteConcepto
    });
  }

  writePermission() {
    return this.conceptosService.writePermission();
  }

  canExport() {
    return this.conceptosService.canExport();
  }
  
  deleteConcepto(){
    this.processing = true;
    this.conceptosService.deleteConcepto(this.conceptoSelected.idConceptos)
      .subscribe(
        response => {
          this.processing = false;
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha eliminado correctamente el concepto seleccionado'
          });

          this.getConceptos();
      },error => {
          this.processing = false;

          // resolviendo errores 403 y 500. sin notifications
          this.helperService.httpGlobalError(error, false);

          if (error.status == 400 || error.status == 500) {
            this.errorModal.open({
              'title': 'Error',
              'description': 'Ha ocurrido un error al intentar eliminar el concepto, inténtelo más tarde'
            });
          }
      });
  }

  searchConcepto(page = null){
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }

    if (this.searchText.length > 1){
      this.searchProcess = this.conceptosService.searchConceptos(this.searchText, page)
          .subscribe(response => {
            let content = response.json().content;
            this.conceptos = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.conceptos.length > 0)? false: 'not_found';
          }, error => {
            // resolviendo errores 403 y 500. sin notifications
            this.helperService.httpGlobalError(error, false);
          });
    } else {
      this.getConceptos();
    }
  }

  getConceptos(page = null){
    this.searchProcess = this.conceptosService.getConceptos(page)
      .subscribe(response => {
        let content = response.json().content;
        this.conceptos = content.data;
        this.startPaginate(content);
        this.searchProcess = false;
        this.alterTable = (this.conceptos.length > 0)? false: 'not_result';
      }, error => {
        // resolviendo errores 403 y 500. sin notifications
        this.helperService.httpGlobalError(error);
      });
  }

  createConcepto(){
    this.errors = [];
    this.errors = this.conceptosService.validateConcepto(this.conceptoSelected)

    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    this.conceptoSelected.idTipo_Clasificacion = this.conceptoSelected.tipo_clasificacion.idTipo_Clasificacion;
    this.conceptoSelected.idTipo_Gasto = (this.conceptoSelected.tipo_gasto.idTipo_Gasto || 0);
    this.conceptoSelected.idTipo_Ingreso = (this.conceptoSelected.tipo_ingreso.idTipo_Ingreso || 0);
    this.conceptoSelected.idTipo_Movimiento = this.conceptoSelected.tipo_movimiento.idTipo_Movimiento;
    this.conceptoSelected.honorario = (this.conceptoSelected.honorario)?1:0;
    this.conceptoSelected.balcasa = (this.conceptoSelected.balcasa)?1:0;
    this.conceptoSelected.visible_en_contratos = (this.conceptoSelected.visible_en_contratos)?1:0;

    if(this.conceptoSelected.idTipo_Movimiento==4 && this.conceptoSelected.idTipo_Ingreso == 0 && this.conceptoSelected.idTipo_Gasto == 0){
      this.isValid = 'Seleccione tipo de egreso y tipo de ingreso';
    }
    else if(this.conceptoSelected.idTipo_Movimiento==1 && this.conceptoSelected.idTipo_Gasto == 0){
      this.isValid = 'Seleccione tipo de egreso';
    }
    else if(this.conceptoSelected.idTipo_Movimiento==2 && this.conceptoSelected.idTipo_Ingreso == 0){
      this.isValid = 'Seleccione tipo de ingreso';
    }
    else if(this.conceptoSelected.idTipo_Ingreso == 0 && this.conceptoSelected.idTipo_Gasto == 0){
      this.isValid = 'Seleccione tipo de ingreso o egreso';
    }
    else{
      this.processing = true;
     this.conceptosService.createConcepto(this.conceptoSelected)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        if (respuesta.success) {
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha creado correctamente el concepto'
          });
          this.conceptoSelected.idConceptos = respuesta.content.id;
          this.goPage(1);
          this.isValid = '';
        }
      }, error => {
        this.processing = false;

        // resolviendo errores 403 y 500. sin notifications
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
        }

        if (error.status == 400 || error.status == 500) {
          this.errorModal.open({
            'title': 'Error!',
            'description': 'No se ha podido guardar el concepto, inténtelo más tarde'
          });
        }
      });
    }
  }

  updateConcepto(){
    this.errors = [];
    this.errors = this.conceptosService.validateConcepto(this.conceptoSelected)
    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    this.conceptoSelected.honorario = (this.conceptoSelected.honorario)?1:0;
    this.conceptoSelected.balcasa = (this.conceptoSelected.balcasa)?1:0;
    this.conceptoSelected.visible_en_contratos = (this.conceptoSelected.visible_en_contratos)?1:0;
    this.conceptoSelected.idTipo_Clasificacion = this.conceptoSelected.tipo_clasificacion.idTipo_Clasificacion;
    this.conceptoSelected.idTipo_Gasto = this.conceptoSelected.tipo_gasto.idTipo_Gasto;
    this.conceptoSelected.idTipo_Ingreso = this.conceptoSelected.tipo_ingreso.idTipo_Ingreso;
    this.conceptoSelected.idTipo_Movimiento = this.conceptoSelected.tipo_movimiento.idTipo_Movimiento;

    if(this.conceptoSelected.idTipo_Movimiento==4 && this.conceptoSelected.idTipo_Ingreso == 0 && this.conceptoSelected.idTipo_Gasto == 0){
      this.isValid = 'Seleccione tipo de egreso y tipo de ingreso';
    }
    else if(this.conceptoSelected.idTipo_Movimiento==1 && this.conceptoSelected.idTipo_Gasto == 0){
      this.isValid = 'Seleccione tipo de egreso';
    }
    else if(this.conceptoSelected.idTipo_Movimiento==2 && this.conceptoSelected.idTipo_Ingreso == 0){
      this.isValid = 'Seleccione tipo de ingreso';
    }
    else if(this.conceptoSelected.idTipo_Ingreso == 0 && this.conceptoSelected.idTipo_Gasto == 0){
      this.isValid = 'Seleccione tipo de ingreso o egreso';
    }
    else{
      this.processing = true;
      this.conceptosService.updateConcepto(this.conceptoSelected, this.conceptoSelected.idConceptos)
      .subscribe(response => {
        this.processing = false;
        if(response.json().success){
          this.helperService.notification('¡Éxito!', 'Se ha editado correctamente el concepto', 'success');
          this.goPage(this.currentPage);
          this.isValid = '';
        }
      }, error => {
        this.processing = false;

        // resolviendo errores 403 y 500. sin notifications
        this.helperService.httpGlobalError(error);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde', 'error');
        }
      });
    }
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  conceptoSelectedWithId(){
    if(! this.conceptoSelected)
      return false;

    return (this.conceptoSelected.idConceptos);
  }

  cancelarConceptoSelected(){
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetConceptoSelected
    });
  }

  // MODAL FUNCTIONS

  modalCallback(callback){
    callback();
  }

  // MAIN SECTIONS FUNCTIONS 

  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for(let i = 1; i <= this.paginate.last_page; i++){
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage() {
    this.goPage(this.paginate.current_page - 1);
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {
    if (this.searchText) {
      this.searchConcepto(page);
    } else {
      this.getConceptos(page);
    }
  }

  changeSwitchListado(){
    if(!this.mostrarListado){
      this.conceptoSelected = this.conceptosService.getDefaultSchedule();
    }
  }

  export() {
    this.exporting = true;
    this.conceptosService.export(this.searchText)
      .subscribe((response) => {
        this.exporting = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-conceptos/catalogo-conceptos.component.ts